import React from 'react';

import { SocketIOContextProvider } from './hooks/SocketIOHook';
import { AppLogicContextProvider } from './hooks/AppLogicHook';

const Providers = ({ children }) => {
  return (
    <SocketIOContextProvider>
      <AppLogicContextProvider>{children}</AppLogicContextProvider>
    </SocketIOContextProvider>
  );
};

export default Providers;
